import { render, staticRenderFns } from "./session-rate.vue?vue&type=template&id=dcb3cb48"
import script from "./session-rate.vue?vue&type=script&lang=js"
export * from "./session-rate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports